import axios from 'axios';

import config from '../utils/config';
import { currentProductName$ } from '../selectors/product';
import {
  authIdInputValue$,
  emailInputValue$,
} from '../selectors/findUser';

import * as FindUserActions from '../actions/findUser';
import * as CommentsCreators from './comments';

import ReduxAction from '../interfaces/ReduxAction';

const URL = config().findUser;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const findUser = (): ReduxAction => {
  return (dispatch, getState): void => {
    const params = new URLSearchParams();

    function paramsAppender (paramName, paramVal) {
      if (paramVal) {
        return params.append(paramName, paramVal);
      } else {
        return null;
      }
    }

    if (authIdInputValue$(getState()) || emailInputValue$(getState())) {
      dispatch(FindUserActions.fetchFindUserPendingAction());
      paramsAppender('customer_id', authIdInputValue$(getState()));
      paramsAppender('customer_email', emailInputValue$(getState()));
      paramsAppender('product', currentProductName$(getState()));
      axios({
        method: 'post',
        url: URL,
        data: params,
      })
        .then(response => {
          dispatch(FindUserActions.fetchFindUserSuccessAction(response.data));
          dispatch(CommentsCreators.comments());
        })
        .catch(() => {
          dispatch(FindUserActions.fetchFindUserFailAction());
        });
    }
  };
};
